import Moment from 'moment'
import { extendMoment } from 'moment-range'

export default extendMoment(Moment)
